import { LoginPayload, VerifyTwoFactorPayload } from 'types/auth';
import axiosInstance from './axios';

export const authService = {

    /**
     * Password step only — sets no cookies. The response is a two-factor
     * challenge; the session is opened by verifyTwoFactor() below.
     */
    loginUser: async (credentials: LoginPayload) => {
        const response = await axiosInstance.post('/admin/auth/login', credentials);
        return response.data;
    },

    /** Second step: exchanges the challenge + authenticator code for a session. */
    verifyTwoFactor: async (payload: VerifyTwoFactorPayload) => {
        const response = await axiosInstance.post('/admin/auth/2fa/verify', payload);
        return response.data;
    },

    /**
     * Issues a fresh authenticator QR for an admin (super-admin only) — the
     * lost-phone path. Whatever that admin had enrolled stops working, and
     * their next login walks the setup flow with the new QR.
     */
    setupTwoFactor: async (adminId: number) => {
        const response = await axiosInstance.post(`/admin/auth/2fa/setup/${adminId}`);
        return response.data;
    },

    logoutUser: async () => {
        const response = await axiosInstance.post('/admin/auth/logout',);
        return response.data;
    },

    fetchCurrentUser: async () => {
        const response = await axiosInstance.get('/admin/auth/me');
        return response.data;
    },

};
